import { NavigationExtras } from '@angular/router';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class DataExchangeService {

    constructor() {

    }

    private _object: any;

    set passon(l: any) {
        this._object = l;
    }


    get passon(): any {
        const tmp: NavigationExtras = this._object;
        this._object = undefined;
        return tmp;
    }


    private _key: any;

    set authkey(k: any) {
        this._key = k;
    }

    get authkey(): any {
        return this._key;
    }

}